import RegisterModalContent from './RegisterModalContent';

export default RegisterModalContent;